<script setup lang="ts">
import { ref } from "vue";
import { useLoadScript, mapTDTJSSDK } from "@zyzgroup/core-web";
import Box from "../base/Box.vue";

const props = withDefaults(
  defineProps<{
    mapKey?: string;
    mapContainerID?: string;
    mapWidth?: string;
    mapHeight?: string;
    mapZoom?: number;
    // longitude
    mapCenterLng?: number;
    // latitude
    mapCenterLat?: number;
  }>(),
  {
    mapKey: "8261564c2f1435b76dc5991adad737e6",
    mapContainerID: "mapTiandituDiv",
    mapZoom: 18,
    mapCenterLng: 120.619585,
    mapCenterLat: 31.299379
  }
);

const emits = defineEmits<{
  (event: "click"): void;
}>();

function mount() {
  useLoadScript(`http://api.tianditu.gov.cn/api?v=4.0&tk=${props.mapKey}`)
    .then(() => {
      new mapTDTJSSDK(
        props.mapContainerID,
        props.mapCenterLng,
        props.mapCenterLat,
        props.mapZoom
      );
    })
    .catch((e) => {
      console.log("error", e);
    });
}

const mapWidth = ref(props.mapWidth);
const mapHeight = ref(props.mapHeight);
function resize(box) {
  mapWidth.value = box.rect.width + "px";
  mapHeight.value = box.rect.height + "px";
}

defineExpose({});
</script>

<template>
  <Box
    display-type="full"
    @mount="mount"
    @resize="resize"
  >
    <slot
      :width="mapWidth"
      :height="mapHeight"
    >
      <!-- 天地图动态注入的样式，目前在ce shadow root 中无法使用 -->
      <!--
        所以注入
        <div id="mapTiandituDiv" style="width: 100%; height: 100%"></div>
      -->
    </slot>
  </Box>
</template>

<style scoped></style>
